import { UTILITY_PROP_NAMES as SHARED_UTILITY_PROP_NAMES, isUtilityPropName as sharedIsUtilityPropName, } from '@smoothie-framework/ui-core/schemas/utility-prop-names';
const CANONICAL_UTILITY_DESCRIPTORS = Object.freeze({
    gap: { utility: 'gap', classPrefix: 'gap', cssProperties: ['gap'], spacingNumeric: true },
    gapX: {
        utility: 'gapX',
        classPrefix: 'gap-x',
        cssProperties: ['column-gap'],
        spacingNumeric: true,
    },
    gapY: { utility: 'gapY', classPrefix: 'gap-y', cssProperties: ['row-gap'], spacingNumeric: true },
    columns: {
        utility: 'columns',
        classPrefix: 'grid-cols',
        cssProperties: ['grid-template-columns'],
    },
    rows: {
        utility: 'rows',
        classPrefix: 'grid-rows',
        cssProperties: ['grid-template-rows'],
    },
    areas: {
        utility: 'areas',
        classPrefix: 'grid-areas',
        cssProperties: ['grid-template-areas'],
    },
    flow: {
        utility: 'flow',
        classPrefix: 'grid-flow',
        cssProperties: ['grid-auto-flow'],
        keywordMap: {
            row: 'row',
            column: 'column',
            dense: 'dense',
            'row-dense': 'row dense',
            'column-dense': 'column dense',
        },
    },
    autoRows: {
        utility: 'autoRows',
        classPrefix: 'auto-rows',
        cssProperties: ['grid-auto-rows'],
    },
    autoColumns: {
        utility: 'autoColumns',
        classPrefix: 'auto-cols',
        cssProperties: ['grid-auto-columns'],
    },
    inline: {
        utility: 'inline',
        classPrefix: 'grid',
        cssProperties: ['display'],
    },
    area: {
        utility: 'area',
        classPrefix: 'grid-area',
        cssProperties: ['grid-area'],
    },
    colSpan: {
        utility: 'colSpan',
        classPrefix: 'col-span',
        cssProperties: ['grid-column'],
    },
    colStart: {
        utility: 'colStart',
        classPrefix: 'col-start',
        cssProperties: ['grid-column-start'],
    },
    colEnd: {
        utility: 'colEnd',
        classPrefix: 'col-end',
        cssProperties: ['grid-column-end'],
    },
    rowSpan: {
        utility: 'rowSpan',
        classPrefix: 'row-span',
        cssProperties: ['grid-row'],
    },
    rowStart: {
        utility: 'rowStart',
        classPrefix: 'row-start',
        cssProperties: ['grid-row-start'],
    },
    rowEnd: {
        utility: 'rowEnd',
        classPrefix: 'row-end',
        cssProperties: ['grid-row-end'],
    },
    align: {
        utility: 'align',
        classPrefix: 'items',
        cssProperties: ['align-items'],
        keywordMap: {
            start: 'flex-start',
            center: 'center',
            end: 'flex-end',
            stretch: 'stretch',
            baseline: 'baseline',
        },
    },
    alignItems: {
        utility: 'alignItems',
        classPrefix: 'items',
        cssProperties: ['align-items'],
        keywordMap: {
            start: 'flex-start',
            center: 'center',
            end: 'flex-end',
            stretch: 'stretch',
            baseline: 'baseline',
        },
    },
    alignContent: {
        utility: 'alignContent',
        classPrefix: 'content',
        cssProperties: ['align-content'],
        keywordMap: {
            start: 'flex-start',
            center: 'center',
            end: 'flex-end',
            between: 'space-between',
            around: 'space-around',
            evenly: 'space-evenly',
            stretch: 'stretch',
            baseline: 'baseline',
        },
    },
    alignSelf: {
        utility: 'alignSelf',
        classPrefix: 'self',
        cssProperties: ['align-self'],
        keywordMap: {
            auto: 'auto',
            start: 'flex-start',
            center: 'center',
            end: 'flex-end',
            stretch: 'stretch',
            baseline: 'baseline',
        },
    },
    justify: {
        utility: 'justify',
        classPrefix: 'justify',
        cssProperties: ['justify-content'],
        keywordMap: {
            start: 'flex-start',
            center: 'center',
            end: 'flex-end',
            between: 'space-between',
            around: 'space-around',
            evenly: 'space-evenly',
        },
    },
    justifyContent: {
        utility: 'justifyContent',
        classPrefix: 'justify',
        cssProperties: ['justify-content'],
        keywordMap: {
            start: 'flex-start',
            center: 'center',
            end: 'flex-end',
            between: 'space-between',
            around: 'space-around',
            evenly: 'space-evenly',
        },
    },
    justifyItems: {
        utility: 'justifyItems',
        classPrefix: 'justify-items',
        cssProperties: ['justify-items'],
        keywordMap: {
            start: 'start',
            center: 'center',
            end: 'end',
            stretch: 'stretch',
            normal: 'normal',
        },
    },
    justifySelf: {
        utility: 'justifySelf',
        classPrefix: 'justify-self',
        cssProperties: ['justify-self'],
        keywordMap: {
            auto: 'auto',
            start: 'start',
            center: 'center',
            end: 'end',
            stretch: 'stretch',
            normal: 'normal',
        },
    },
    placeContent: {
        utility: 'placeContent',
        classPrefix: 'place-content',
        cssProperties: ['place-content'],
        keywordMap: {
            start: 'start',
            center: 'center',
            end: 'end',
            between: 'space-between',
            around: 'space-around',
            evenly: 'space-evenly',
            stretch: 'stretch',
        },
    },
    placeItems: {
        utility: 'placeItems',
        classPrefix: 'place-items',
        cssProperties: ['place-items'],
        keywordMap: {
            start: 'start',
            center: 'center',
            end: 'end',
            stretch: 'stretch',
            normal: 'normal',
        },
    },
    placeSelf: {
        utility: 'placeSelf',
        classPrefix: 'place-self',
        cssProperties: ['place-self'],
        keywordMap: {
            auto: 'auto',
            start: 'start',
            center: 'center',
            end: 'end',
            stretch: 'stretch',
            normal: 'normal',
        },
    },
    direction: {
        utility: 'direction',
        classPrefix: 'flex',
        cssProperties: ['flex-direction'],
    },
    display: {
        utility: 'display',
        classPrefix: 'display',
        cssProperties: ['display'],
    },
    hideFrom: {
        utility: 'hideFrom',
        classPrefix: 'hide-from',
        cssProperties: ['display'],
    },
    hideBelow: {
        utility: 'hideBelow',
        classPrefix: 'hide-below',
        cssProperties: ['display'],
    },
    wrap: {
        utility: 'wrap',
        classPrefix: 'flex',
        cssProperties: ['flex-wrap'],
    },
    padding: { utility: 'padding', classPrefix: 'p', cssProperties: ['padding'], spacingNumeric: true },
    paddingX: {
        utility: 'paddingX',
        classPrefix: 'px',
        cssProperties: ['padding-left', 'padding-right'],
        spacingNumeric: true,
    },
    paddingY: {
        utility: 'paddingY',
        classPrefix: 'py',
        cssProperties: ['padding-top', 'padding-bottom'],
        spacingNumeric: true,
    },
    paddingTop: {
        utility: 'paddingTop',
        classPrefix: 'pt',
        cssProperties: ['padding-top'],
        spacingNumeric: true,
    },
    paddingRight: {
        utility: 'paddingRight',
        classPrefix: 'pr',
        cssProperties: ['padding-right'],
        spacingNumeric: true,
    },
    paddingBottom: {
        utility: 'paddingBottom',
        classPrefix: 'pb',
        cssProperties: ['padding-bottom'],
        spacingNumeric: true,
    },
    paddingLeft: {
        utility: 'paddingLeft',
        classPrefix: 'pl',
        cssProperties: ['padding-left'],
        spacingNumeric: true,
    },
    paddingStart: {
        utility: 'paddingStart',
        classPrefix: 'ps',
        cssProperties: ['padding-inline-start'],
        spacingNumeric: true,
    },
    paddingEnd: {
        utility: 'paddingEnd',
        classPrefix: 'pe',
        cssProperties: ['padding-inline-end'],
        spacingNumeric: true,
    },
    margin: {
        utility: 'margin',
        classPrefix: 'm',
        cssProperties: ['margin'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginX: {
        utility: 'marginX',
        classPrefix: 'mx',
        cssProperties: ['margin-left', 'margin-right'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginY: {
        utility: 'marginY',
        classPrefix: 'my',
        cssProperties: ['margin-top', 'margin-bottom'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginTop: {
        utility: 'marginTop',
        classPrefix: 'mt',
        cssProperties: ['margin-top'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginRight: {
        utility: 'marginRight',
        classPrefix: 'mr',
        cssProperties: ['margin-right'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginBottom: {
        utility: 'marginBottom',
        classPrefix: 'mb',
        cssProperties: ['margin-bottom'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginLeft: {
        utility: 'marginLeft',
        classPrefix: 'ml',
        cssProperties: ['margin-left'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginStart: {
        utility: 'marginStart',
        classPrefix: 'ms',
        cssProperties: ['margin-inline-start'],
        allowAuto: true,
        spacingNumeric: true,
    },
    marginEnd: {
        utility: 'marginEnd',
        classPrefix: 'me',
        cssProperties: ['margin-inline-end'],
        allowAuto: true,
        spacingNumeric: true,
    },
    spaceX: {
        utility: 'spaceX',
        classPrefix: 'space-x',
        cssProperties: ['margin-inline-start'],
        spacingNumeric: true,
    },
    spaceY: {
        utility: 'spaceY',
        classPrefix: 'space-y',
        cssProperties: ['margin-block-start'],
        spacingNumeric: true,
    },
    translateX: {
        utility: 'translateX',
        classPrefix: 'translate-x',
        cssProperties: ['translate'],
        spacingNumeric: true,
    },
    translateY: {
        utility: 'translateY',
        classPrefix: 'translate-y',
        cssProperties: ['translate'],
        spacingNumeric: true,
    },
    width: { utility: 'width', classPrefix: 'w', cssProperties: ['width'] },
    height: { utility: 'height', classPrefix: 'h', cssProperties: ['height'] },
    minWidth: { utility: 'minWidth', classPrefix: 'min-w', cssProperties: ['min-width'] },
    maxWidth: { utility: 'maxWidth', classPrefix: 'max-w', cssProperties: ['max-width'] },
    minHeight: { utility: 'minHeight', classPrefix: 'min-h', cssProperties: ['min-height'] },
    maxHeight: { utility: 'maxHeight', classPrefix: 'max-h', cssProperties: ['max-height'] },
    basis: { utility: 'basis', classPrefix: 'basis', cssProperties: ['flex-basis'] },
    zIndex: { utility: 'zIndex', classPrefix: 'z', cssProperties: ['z-index'] },
    grow: { utility: 'grow', classPrefix: 'grow', cssProperties: ['flex-grow'] },
    shrink: { utility: 'shrink', classPrefix: 'shrink', cssProperties: ['flex-shrink'] },
    background: { utility: 'background', classPrefix: 'bg', cssProperties: ['background'] },
    backgroundColor: {
        utility: 'backgroundColor',
        classPrefix: 'bg',
        cssProperties: ['background-color'],
    },
    color: { utility: 'color', classPrefix: 'text', cssProperties: ['color'] },
    boxShadow: { utility: 'boxShadow', classPrefix: 'shadow', cssProperties: ['box-shadow'] },
    boxSizing: { utility: 'boxSizing', classPrefix: 'box-sizing', cssProperties: ['box-sizing'] },
    cursor: { utility: 'cursor', classPrefix: 'cursor', cssProperties: ['cursor'] },
    border: { utility: 'border', classPrefix: 'border-all', cssProperties: ['border'] },
    borderTop: { utility: 'borderTop', classPrefix: 'border-t', cssProperties: ['border-top'] },
    borderBottom: { utility: 'borderBottom', classPrefix: 'border-b', cssProperties: ['border-bottom'] },
    borderLeft: { utility: 'borderLeft', classPrefix: 'border-l', cssProperties: ['border-left'] },
    borderRight: { utility: 'borderRight', classPrefix: 'border-r', cssProperties: ['border-right'] },
    borderStart: { utility: 'borderStart', classPrefix: 'border-s', cssProperties: ['border-inline-start'] },
    borderEnd: { utility: 'borderEnd', classPrefix: 'border-e', cssProperties: ['border-inline-end'] },
    borderX: { utility: 'borderX', classPrefix: 'border-x', cssProperties: ['border-inline'] },
    borderY: { utility: 'borderY', classPrefix: 'border-y', cssProperties: ['border-block'] },
    borderColor: {
        utility: 'borderColor',
        classPrefix: 'border',
        cssProperties: ['border-color'],
    },
    borderTopColor: {
        utility: 'borderTopColor',
        classPrefix: 'border-t-color',
        cssProperties: ['border-top-color'],
    },
    borderBottomColor: {
        utility: 'borderBottomColor',
        classPrefix: 'border-b-color',
        cssProperties: ['border-bottom-color'],
    },
    borderLeftColor: {
        utility: 'borderLeftColor',
        classPrefix: 'border-l-color',
        cssProperties: ['border-left-color'],
    },
    borderRightColor: {
        utility: 'borderRightColor',
        classPrefix: 'border-r-color',
        cssProperties: ['border-right-color'],
    },
    borderStartColor: {
        utility: 'borderStartColor',
        classPrefix: 'border-s-color',
        cssProperties: ['border-inline-start-color'],
    },
    borderEndColor: {
        utility: 'borderEndColor',
        classPrefix: 'border-e-color',
        cssProperties: ['border-inline-end-color'],
    },
    borderXColor: {
        utility: 'borderXColor',
        classPrefix: 'border-x-color',
        cssProperties: ['border-inline-color'],
    },
    borderYColor: {
        utility: 'borderYColor',
        classPrefix: 'border-y-color',
        cssProperties: ['border-block-color'],
    },
    borderStyle: {
        utility: 'borderStyle',
        classPrefix: 'border-style',
        cssProperties: ['border-style'],
    },
    borderTopStyle: {
        utility: 'borderTopStyle',
        classPrefix: 'border-t-style',
        cssProperties: ['border-top-style'],
    },
    borderBottomStyle: {
        utility: 'borderBottomStyle',
        classPrefix: 'border-b-style',
        cssProperties: ['border-bottom-style'],
    },
    borderLeftStyle: {
        utility: 'borderLeftStyle',
        classPrefix: 'border-l-style',
        cssProperties: ['border-left-style'],
    },
    borderRightStyle: {
        utility: 'borderRightStyle',
        classPrefix: 'border-r-style',
        cssProperties: ['border-right-style'],
    },
    borderStartStyle: {
        utility: 'borderStartStyle',
        classPrefix: 'border-s-style',
        cssProperties: ['border-inline-start-style'],
    },
    borderEndStyle: {
        utility: 'borderEndStyle',
        classPrefix: 'border-e-style',
        cssProperties: ['border-inline-end-style'],
    },
    borderWidth: {
        utility: 'borderWidth',
        classPrefix: 'border-width',
        cssProperties: ['border-width'],
    },
    borderTopWidth: {
        utility: 'borderTopWidth',
        classPrefix: 'border-t-width',
        cssProperties: ['border-top-width'],
    },
    borderBottomWidth: {
        utility: 'borderBottomWidth',
        classPrefix: 'border-b-width',
        cssProperties: ['border-bottom-width'],
    },
    borderLeftWidth: {
        utility: 'borderLeftWidth',
        classPrefix: 'border-l-width',
        cssProperties: ['border-left-width'],
    },
    borderRightWidth: {
        utility: 'borderRightWidth',
        classPrefix: 'border-r-width',
        cssProperties: ['border-right-width'],
    },
    borderStartWidth: {
        utility: 'borderStartWidth',
        classPrefix: 'border-s-width',
        cssProperties: ['border-inline-start-width'],
    },
    borderEndWidth: {
        utility: 'borderEndWidth',
        classPrefix: 'border-e-width',
        cssProperties: ['border-inline-end-width'],
    },
    borderXWidth: {
        utility: 'borderXWidth',
        classPrefix: 'border-x-width',
        cssProperties: ['border-inline-width'],
    },
    borderYWidth: {
        utility: 'borderYWidth',
        classPrefix: 'border-y-width',
        cssProperties: ['border-block-width'],
    },
    divideX: {
        utility: 'divideX',
        classPrefix: 'divide-x',
        cssProperties: ['border-inline-start-width'],
    },
    divideY: {
        utility: 'divideY',
        classPrefix: 'divide-y',
        cssProperties: ['border-top-width'],
    },
    divideColor: {
        utility: 'divideColor',
        classPrefix: 'divide-color',
        cssProperties: ['--smth-divide-color'],
    },
    divideStyle: {
        utility: 'divideStyle',
        classPrefix: 'divide-style',
        cssProperties: ['--smth-divide-style'],
    },
    outlineColor: {
        utility: 'outlineColor',
        classPrefix: 'outline',
        cssProperties: ['outline-color'],
    },
    borderRadius: { utility: 'borderRadius', classPrefix: 'rounded', cssProperties: ['border-radius'] },
    borderTopLeftRadius: {
        utility: 'borderTopLeftRadius',
        classPrefix: 'rounded-tl',
        cssProperties: ['border-top-left-radius'],
    },
    borderTopRightRadius: {
        utility: 'borderTopRightRadius',
        classPrefix: 'rounded-tr',
        cssProperties: ['border-top-right-radius'],
    },
    borderBottomLeftRadius: {
        utility: 'borderBottomLeftRadius',
        classPrefix: 'rounded-bl',
        cssProperties: ['border-bottom-left-radius'],
    },
    borderBottomRightRadius: {
        utility: 'borderBottomRightRadius',
        classPrefix: 'rounded-br',
        cssProperties: ['border-bottom-right-radius'],
    },
    borderStartStartRadius: {
        utility: 'borderStartStartRadius',
        classPrefix: 'rounded-ss',
        cssProperties: ['border-start-start-radius'],
    },
    borderStartEndRadius: {
        utility: 'borderStartEndRadius',
        classPrefix: 'rounded-se',
        cssProperties: ['border-start-end-radius'],
    },
    borderEndStartRadius: {
        utility: 'borderEndStartRadius',
        classPrefix: 'rounded-es',
        cssProperties: ['border-end-start-radius'],
    },
    borderEndEndRadius: {
        utility: 'borderEndEndRadius',
        classPrefix: 'rounded-ee',
        cssProperties: ['border-end-end-radius'],
    },
    borderInlineStartRadius: {
        utility: 'borderInlineStartRadius',
        classPrefix: 'rounded-s',
        cssProperties: ['border-start-start-radius', 'border-end-start-radius'],
    },
    borderInlineEndRadius: {
        utility: 'borderInlineEndRadius',
        classPrefix: 'rounded-e',
        cssProperties: ['border-start-end-radius', 'border-end-end-radius'],
    },
    borderTopRadius: {
        utility: 'borderTopRadius',
        classPrefix: 'rounded-t',
        cssProperties: ['border-top-left-radius', 'border-top-right-radius'],
    },
    borderBottomRadius: {
        utility: 'borderBottomRadius',
        classPrefix: 'rounded-b',
        cssProperties: ['border-bottom-left-radius', 'border-bottom-right-radius'],
    },
    borderLeftRadius: {
        utility: 'borderLeftRadius',
        classPrefix: 'rounded-l',
        cssProperties: ['border-top-left-radius', 'border-bottom-left-radius'],
    },
    borderRightRadius: {
        utility: 'borderRightRadius',
        classPrefix: 'rounded-r',
        cssProperties: ['border-top-right-radius', 'border-bottom-right-radius'],
    },
    textStyle: {
        utility: 'textStyle',
        classPrefix: 'text-style',
        cssProperties: [],
    },
    textAlign: {
        utility: 'textAlign',
        classPrefix: 'text',
        cssProperties: ['text-align'],
        keywordMap: {
            left: 'left',
            center: 'center',
            right: 'right',
            justify: 'justify',
            start: 'start',
            end: 'end',
        },
    },
    truncate: { utility: 'truncate', classPrefix: 'truncate', cssProperties: ['text-overflow'] },
    uppercase: { utility: 'uppercase', classPrefix: 'uppercase', cssProperties: ['text-transform'] },
    maxLines: { utility: 'maxLines', classPrefix: 'line-clamp', cssProperties: ['-webkit-line-clamp'] },
});
export const UTILITY_PROP_ALIAS_BY_NAME = Object.freeze({
    bg: 'background',
    cols: 'columns',
    p: 'padding',
    px: 'paddingX',
    py: 'paddingY',
    pt: 'paddingTop',
    pr: 'paddingRight',
    pb: 'paddingBottom',
    pl: 'paddingLeft',
    ps: 'paddingStart',
    pe: 'paddingEnd',
    m: 'margin',
    mx: 'marginX',
    my: 'marginY',
    mt: 'marginTop',
    mr: 'marginRight',
    mb: 'marginBottom',
    ml: 'marginLeft',
    ms: 'marginStart',
    me: 'marginEnd',
    rounded: 'borderRadius',
    roundedTopLeft: 'borderTopLeftRadius',
    roundedTopRight: 'borderTopRightRadius',
    roundedBottomLeft: 'borderBottomLeftRadius',
    roundedBottomRight: 'borderBottomRightRadius',
    roundedStartStart: 'borderStartStartRadius',
    roundedStartEnd: 'borderStartEndRadius',
    roundedEndStart: 'borderEndStartRadius',
    roundedEndEnd: 'borderEndEndRadius',
    roundedStart: 'borderInlineStartRadius',
    roundedEnd: 'borderInlineEndRadius',
    roundedTop: 'borderTopRadius',
    roundedBottom: 'borderBottomRadius',
    roundedLeft: 'borderLeftRadius',
    roundedRight: 'borderRightRadius',
    w: 'width',
    h: 'height',
    minW: 'minWidth',
    maxW: 'maxWidth',
    minH: 'minHeight',
    maxH: 'maxHeight',
    shadow: 'boxShadow',
});
function descriptorForAlias(aliasName) {
    const canonicalName = UTILITY_PROP_ALIAS_BY_NAME[aliasName];
    return {
        ...CANONICAL_UTILITY_DESCRIPTORS[canonicalName],
        utility: aliasName,
    };
}
function compareStrings(left, right) {
    if (left < right) {
        return -1;
    }
    if (left > right) {
        return 1;
    }
    return 0;
}
export const UTILITY_DESCRIPTORS = Object.freeze({
    ...CANONICAL_UTILITY_DESCRIPTORS,
    ...Object.fromEntries(Object.keys(UTILITY_PROP_ALIAS_BY_NAME).map((aliasName) => [
        aliasName,
        descriptorForAlias(aliasName),
    ])),
});
const UTILITY_CLASS_PREFIX_ENTRIES = Object.entries(UTILITY_DESCRIPTORS)
    .sort(([left], [right]) => compareStrings(left, right))
    .map(([utility, descriptor]) => [utility, descriptor.classPrefix]);
export const UTILITY_CLASS_PREFIX_BY_PROP = Object.freeze(Object.fromEntries(UTILITY_CLASS_PREFIX_ENTRIES));
export const UTILITY_PROP_NAMES = SHARED_UTILITY_PROP_NAMES;
export function isUtilityPropName(propName) {
    return sharedIsUtilityPropName(propName);
}
export function resolveUtilityPropName(propName) {
    return UTILITY_PROP_ALIAS_BY_NAME[propName] ?? propName;
}
//# sourceMappingURL=core-contract.js.map